module.exports = __webpack_public_path__ + "mf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mf.svg
// module id = 938
// module chunks = 0